import React from 'react';
export function PainSection() {
  return <section className="py-6 px-4 bg-white border-t border-gray-100" data-id="element-89" data-mp="1rs43zm8c0j9k">
      <div className="max-w-3xl mx-auto text-center md:text-left" data-id="element-90" data-mp="38wvlym7az9q2">
        <h2 className="text-[20px] font-black mb-4 text-center text-[#EF5B4C]" data-id="element-91" data-mp="2uyfdoqtslb5t">
          Si sos docente, dejame hacerte una pregunta:
        </h2>

        <p className="text-xl md:text-2xl font-bold text-[#EF5B4C] mb-3 text-center" data-id="element-92" data-mp="2yy62iozrdh7p">
          ¿Sentís que pasás horas buscando actividades de ESI para cada tema que
          necesitás trabajar?
        </p>

        <div className="text-lg text-gray-700 space-y-2 mb-4" data-id="element-93" data-mp="2q0dmfim7q5j9">
          <p data-id="element-94" data-mp="2bb7nlvraehbw">
            Entre planificaciones, clases, actos, reuniones y correcciones,
            muchas veces terminás buscando recursos en distintos lugares,
            adaptando materiales o armando propuestas desde cero.
          </p>
        </div>

        <p className="text-lg text-gray-700 font-medium" data-id="element-95" data-mp="22buex5azlws8">
          Y cuando surge una situación en el aula, necesitás actuar rápido y no
          siempre tenés actividades listas para acompañar ese momento.
        </p>

        <p className="text-xl font-bold text-center mt-4 text-gray-900" data-id="element-96" data-mp="3nlyrau2xg00g">
          La ESI no debería significar más horas de preparación.
        </p>
      </div>
    </section>;
}